import React from 'react';
import {
  ClipboardList, Boxes, Container, MapPin, Truck, ArrowLeftRight,
  Anchor, FileCheck, MapPinned, Shield,
  LayoutList, Wrench, Users, ShieldCheck
} from 'lucide-react';
import ServicePageTemplate from '../components/ServicePageTemplate';

const ProjectLogistics = () => {
  return (
    <ServicePageTemplate
      heroTitle="Project Logistics"
      heroImage="/img/project.jpg"
      slug="project-logistics"
      introText={[
        'Denver Logistics Private Limited specializes in end-to-end project logistics solutions for oversized, heavy-lift, and high-value cargo.',
        'From detailed planning and route surveys to transportation, customs clearance, and final delivery, we manage every stage with precision and efficiency.',
        'Backed by an experienced team and a global network of partners, we ensure safe, reliable, and on-time execution of complex logistics projects across industries.',
      ]}
      services={[
        'End-to-End Project Planning',
        'Heavy Lift & Oversized Cargo',
        'Breakbulk Cargo Solutions',
        'Route Survey & Feasibility Study',
        'Specialized Transport Equipment',
        'Multimodal Transportation',
        'Port Handling & Terminal Ops',
        'Customs Clearance',
        'Cargo Tracking & Real-Time Updates',
        'Risk Management & Cargo Insurance',
      ]}
      serviceIcons={[
        ClipboardList, Boxes, Container, MapPin, Truck, ArrowLeftRight,
        Anchor, FileCheck, MapPinned, Shield
      ]}
      benefits={[
        { title: 'End-to-End Management', description: 'Complete project lifecycle management from planning to final delivery.' },
        { title: 'Specialized Equipment', description: 'Access to specialized transport equipment for oversized cargo.' },
        { title: 'Expert Team', description: 'Experienced professionals with deep project logistics expertise.' },
        { title: 'Risk Management', description: 'Comprehensive risk assessment and cargo insurance coverage.' },
      ]}
      benefitIcons={[LayoutList, Wrench, Users, ShieldCheck]}
      callout={{
        eyebrow: 'HAVE A COMPLEX PROJECT?',
        sub: 'We make it possible.',
        ctaLabel: 'DISCUSS YOUR PROJECT',
      }}
      faq={[
        { q: 'What types of project cargo can you handle?', a: 'We handle oversized, heavy-lift, and high-value cargo including industrial machinery, power plant equipment, oil & gas modules, wind turbine components, transformers, and construction equipment.' },
        { q: 'Do you conduct route surveys?', a: 'Yes. For oversized and heavy cargo, we conduct detailed route surveys and feasibility studies to identify the safest and most efficient transportation routes, including bridge load limits, road widths, and permit requirements.' },
        { q: 'What is breakbulk cargo?', a: 'Breakbulk refers to goods that are too large or heavy for standard containers and must be loaded individually onto vessels. This includes steel, machinery, pipes, and project equipment. We specialize in breakbulk handling and stowage.' },
      ]}
    />
  );
};

export default ProjectLogistics;
